module.exports = __webpack_public_path__ + "img/terroir-bright-1.716332b7.jpg";